
import React from 'react'
import { withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import { translate } from 'react-switch-lang'

import MyController from '../../core/components/MyController'
import ViewUpdateEvent from '../../views/event/ViewUpdateEvent'
import SettingManager from '../../business/SettingManager'
import EventManager from '../../business/EventManager'
import UserManager from '../../business/UserManager'
import UserGroupManager from '../../business/UserGroupManager'

class CreateEventController extends MyController {
	constructor(props) {
		super(props)
		this.state.isLoading = false
		this.bSetting = new SettingManager(this)
		this.bEvent = new EventManager(this)
		this.bUser = new UserManager(this)
		this.bUserGroup = new UserGroupManager(this)
	}

	onGetEventInfo = (userEmail, eventId) => {
		return this.bEvent.getEventInfo(userEmail, eventId)
	}

	onGetSetting = () => {
		return this.bSetting.getFrontendSetting()
	}

	onGetConferenceList = () => {
		return this.bSetting.getConferenceList()
	}

	onGetEventType = () => {
		return this.bEvent.getEventType()
	}

	onGetEventRoomFormat = () => {
		return this.bEvent.getEventRoomFormat()
	}

	onUpdateEvent = (eventId, organizerAddress, body) => {
		return this.bEvent.updateEvent(eventId, organizerAddress, body)
	}

	onGetUserMailSystem = (textSearch) => {
		return this.bUser.getUserMailSystem(textSearch)
	}

	onGetUserGroupList = (textSearch) => {
		return this.bUserGroup.getUserGroupList(textSearch)
	}
	render() {
		return (
			<React.Fragment>
				{super.render()}
				<ViewUpdateEvent
					onGetEventInfo={this.onGetEventInfo}
					onGetSetting={this.onGetSetting}
					onGetConferenceList={this.onGetConferenceList}
					onGetEventType={this.onGetEventType}
					onGetEventRoomFormat={this.onGetEventRoomFormat}
					onUpdateEvent={this.onUpdateEvent}
					onGetUserMailSystem={this.onGetUserMailSystem}
					onGetUserGroupList={this.onGetUserGroupList}
				/>
			</React.Fragment>
		)
	}
}

const enhance = compose(
	translate,
	withRouter,
)


export default enhance(CreateEventController)